import { unsafeCSS } from 'lit';

const trustedCSS = unsafeCSS;
function wrapInCssLayer(input, layerName = "vendor.components") {
  const template = `
		@layer ${layerName} {
			${input.join("\n")}
		}
	`;
  return trustedCSS(template);
}
function replaceRootWithHost(input) {
  return input.replace(/:root/g, ":host");
}

export { replaceRootWithHost, trustedCSS, wrapInCssLayer };
